var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolyellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.684+386.677L873.375+386.677C891.686+386.677+906.53+399.186+906.53+414.615L906.53+815.409C906.53+830.839+891.686+843.347+873.375+843.347L149.684+843.347C131.374+843.347+116.53+830.839+116.53+815.409L116.53+414.615C116.53+399.186+131.374+386.677+149.684+386.677Z",
    opacity: 1,
    fill: "#ffe34a"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M347.43+384.818C347.43+384.818+486.177+248.246+494.391+233.773C502.605+219.3+523.477+214.139+533.623+224.567L678.092+384.818C688.238+395.245+680.013+403.698+659.722+403.698L365.801+403.698C345.509+403.698+337.285+395.245+347.43+384.818Z",
    fill: "#ffe34a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e55f00",
    d: "M660.242+266.103L660.242+266.103L660.242+266.991L660.242+266.991L660.242+266.103Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7220",
    opacity: 1,
    d: "M535.989+160.07L535.989+160.07C547.657+171.825+547.657+190.882+535.989+202.637L345.168+394.882C333.501+406.637+314.584+406.637+302.917+394.882L302.917+394.882C291.249+383.128+291.249+364.07+302.917+352.316L493.738+160.07C505.405+148.316+524.322+148.316+535.989+160.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7220",
    opacity: 1,
    d: "M496.63+160.986L496.63+160.986C484.962+172.741+484.962+191.799+496.63+203.553L687.454+395.799C699.122+407.553+718.038+407.553+729.706+395.799L729.706+395.799C741.374+384.044+741.374+364.986+729.706+353.232L538.882+160.986C527.214+149.232+508.297+149.232+496.63+160.986Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M512.761+578.356L512.761+578.356L512.761+1045.84L512.761+1045.84L512.761+578.356Z",
    fill: "#ffe34a"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M515.562+419.587C574.126+419.587+613.168+458.513+613.168+516.903C613.168+575.293+574.962+615.782+515.981+615.001C456.999+614.22+417.957+575.293+417.957+516.903C417.957+458.513+456.999+419.587+515.562+419.587Z",
    fill: "#e1f5ff",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#0088ff",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    stroke: "#0088ff",
    fill: "#e1f5ff",
    strokeLinejoin: "round",
    d: "M515.562+517.299L515.562+517.299L515.562+519.169L515.562+519.169L515.562+517.299Z",
    strokeWidth: 30,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    opacity: 1,
    d: "M514.429+496.56L514.429+465.905",
    fill: "none",
    stroke: "#0088ff",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    stroke: "#0088ff",
    strokeLinecap: "round",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M531.691+532.093L570.229+564.228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.761+672.628L580.779+672.628C610.204+672.628+634.058+702.102+634.058+738.459L634.058+843C636.332+842.078+388.702+843.79+387.482+843L387.482+738.459C387.482+702.102+411.336+672.628+440.761+672.628Z",
    opacity: 1,
    fill: "#ff7220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1f5ff",
    d: "M686.25+442.729L746.646+442.729C753.012+442.729+758.173+446.618+758.173+451.415L758.173+519.707C758.173+524.504+753.012+528.393+746.646+528.393L686.25+528.393C679.883+528.393+674.722+524.504+674.722+519.707L674.722+451.415C674.722+446.618+679.883+442.729+686.25+442.729Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6+442.729L235.996+442.729C242.363+442.729+247.524+446.618+247.524+451.415L247.524+519.707C247.524+524.504+242.363+528.393+235.996+528.393L175.6+528.393C169.234+528.393+164.073+524.504+164.073+519.707L164.073+451.415C164.073+446.618+169.234+442.729+175.6+442.729Z",
    fill: "#e1f5ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#e1f5ff",
    d: "M787.296+442.729L847.692+442.729C854.059+442.729+859.22+446.618+859.22+451.415L859.22+519.707C859.22+524.504+854.059+528.393+847.692+528.393L787.296+528.393C780.93+528.393+775.769+524.504+775.769+519.707L775.769+451.415C775.769+446.618+780.93+442.729+787.296+442.729Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#e1f5ff",
    d: "M276.647+442.729L337.043+442.729C343.409+442.729+348.57+446.618+348.57+451.415L348.57+519.707C348.57+524.504+343.409+528.393+337.043+528.393L276.647+528.393C270.28+528.393+265.119+524.504+265.119+519.707L265.119+451.415C265.119+446.618+270.28+442.729+276.647+442.729Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1f5ff",
    opacity: 1,
    d: "M787.296+539.357L847.692+539.357C854.059+539.357+859.22+543.245+859.22+548.042L859.22+616.334C859.22+621.131+854.059+625.02+847.692+625.02L787.296+625.02C780.93+625.02+775.769+621.131+775.769+616.334L775.769+548.042C775.769+543.245+780.93+539.357+787.296+539.357Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.647+539.357L337.043+539.357C343.409+539.357+348.57+543.245+348.57+548.042L348.57+616.334C348.57+621.131+343.409+625.02+337.043+625.02L276.647+625.02C270.28+625.02+265.119+621.131+265.119+616.334L265.119+548.042C265.119+543.245+270.28+539.357+276.647+539.357Z",
    opacity: 1,
    fill: "#e1f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M686.435+539.357L746.831+539.357C753.198+539.357+758.359+543.245+758.359+548.042L758.359+616.334C758.359+621.131+753.198+625.02+746.831+625.02L686.435+625.02C680.068+625.02+674.907+621.131+674.907+616.334L674.907+548.042C674.907+543.245+680.068+539.357+686.435+539.357Z",
    fill: "#e1f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.786+539.357L236.181+539.357C242.548+539.357+247.709+543.245+247.709+548.042L247.709+616.334C247.709+621.131+242.548+625.02+236.181+625.02L175.786+625.02C169.419+625.02+164.258+621.131+164.258+616.334L164.258+548.042C164.258+543.245+169.419+539.357+175.786+539.357Z",
    opacity: 1,
    fill: "#e1f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M-67.1164+82.3371L-65.4354+82.3371C-64.8165+82.3371-64.3147+82.8388-64.3147+83.4577L-64.3147+83.4577C-64.3147+84.0767-64.8165+84.5784-65.4354+84.5784L-67.1164+84.5784C-67.7353+84.5784-68.2371+84.0767-68.2371+83.4577L-68.2371+83.4577C-68.2371+82.8388-67.7353+82.3371-67.1164+82.3371Z",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolyellow);
export default __webpack_public_path__ + "static/media/School yellow.17f3c294669bebb8d16d06df4162c8fe.svg";
export { ForwardRef as ReactComponent };